// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xi_a bhh_vn bhh_vf bhh_xb bhh_re bhh_tp bhh_qv"};